import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'react-bootstrap/esm/ProgressBar';

const Progres = ({ percentage }) => {
  return (
    <div className='progress'>
      <div
        className='progress-bar progress-bar-striped bg-success'
        role='progressbar'
        style={{ width: `${percentage}%` }}
      >
        {percentage}%
      </div>
    </div>
  );
};

Progres.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export default Progres;
